import { UPIFIELDS } from './types';
import { getString } from '../../constants/Strings';
import { ElementType, sendRioEvent, SpecType, SubType } from '@chegg/commerce-utils';
import { sendRioEventCallback } from '../../utils/CallbackUtils';
export function sendErrorRioEvent(field, rioNamespace) {
  var info = '';
  switch (field) {
    case UPIFIELDS.NAME:
      info = getString('APP.RIO.EVENTS.EL_NAME.UPI_NAME_FIELD_ERROR');
      break;
    case UPIFIELDS.PINCODE:
      info = getString('APP.RIO.EVENTS.EL_NAME.UPI_PINCODE_FIELD_ERROR');
      break;
  }
  sendRioEvent({
    info: info,
    force: false,
    subType: SubType.ERROR,
    namespace: rioNamespace,
    elementType: ElementType.TEXT,
    callback: sendRioEventCallback,
    specType: SpecType.NOTIFICATION,
    message_detail: getString('APP.RIO.EVENTS.EL_NAME.UPI_FIELD_ERROR.MESSAGE_DETAIL')
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/UpiOption/sendErrorRioEvent.js
// module id = 4594
// module chunks = 11